import axios from "axios";
import config from "../config";

export function getZapierApiKey() {
  return axios.get(`${config.api_url}/zapier-api-key`);
}
